// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";

// Firebase konsolundan aldığın config objesi:
const firebaseConfig = {
  apiKey: "AIzaSyBclWSX_U0GAeJVOXiD6RhBNg_PdZ3gQkE",
  authDomain: "soundcode-8ad4f.firebaseapp.com",
  projectId: "soundcode-8ad4f",
  storageBucket: "soundcode-8ad4f.firebasestorage.app",
  messagingSenderId: "908548502096",
  appId: "1:908548502096:web:71ab3dc8f8dacc06261755",
  measurementId: "G-6DDHTXJJ85"
};

// Firebase'i başlat
const app = initializeApp(firebaseConfig);

// Auth servisi
export const auth = getAuth(app);

// Firestore servisi - basit şekilde
export const db = getFirestore(app);

// Eğer localhost'ta emulator kullanıyorsan bu satırları aç (yoksa kapat):
// if (window.location.hostname === 'localhost') {
//   connectAuthEmulator(auth, "http://localhost:9099");
//   connectFirestoreEmulator(db, 'localhost', 8080);
// }

export default app;